// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/fonts/Thicker-Regular.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
@font-face {
  font-family: lightThicker;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

@font-face {
  font-family: mediumThicker;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.footer_wrapper {
  width: 100%;
  background: #262626;
  display: flex;
  align-items: center;
  justify-content: center;
}

.footer_main_div {
  width:100%;
  padding: 0 6vw;
}

.footer_top_container {
  padding: 47px 0 60px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.footer_social_div {
  margin-top: 20px;
}

.footer_social_div > p {
  font-family: mediumThicker;
  color: #fff;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}

.footer_social_icons {
  display: flex;
  gap: 12px;
  cursor: pointer;
  margin-top: 10px;
}

.footer_logo_div {
  width: 230px;
}

.footer_right_container {
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  justify-content: space-between;
  gap: 66px;
}

.footer_right_sub_container {
  display: flex;
  flex-direction: row;
  gap: 66px;
}

.footer_card > p {
  color: #fff;
  font-family: Thicker;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;

}


.footer_card > ul {
  margin-top: 29px;
  padding: 0px;
}
.comingSoon{
  font-size: 12px;
  color: crimson;
}
.footer_li {
  list-style: none;
  color: #fff;
  font-family: mediumThicker;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  cursor: pointer;
  margin-bottom: 18px;
  padding: 0;
  transition:         color 0.1s;
}
.footer_li:hover {
  color: rgb(198, 196, 196);
}
.footer_bottom_container_wrapper {
  width: 100%;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  background: #262626;
  display: flex;
  align-items: center;
  justify-content: center;
}

.footer_bottom_container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 6vw;}

.footer_bottom_copyright_div > p {
  color: #fff;
  font-family: lightThicker;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 40px;
}

.footer_bottom_privacy_policy_div {
  display: flex;
  flex-direction: row;
  gap: 48px;
}

.footer_bottom_privacy_policy_div > p {
  color: #fff;
  font-family: lightThicker;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 40px; /* 285.714% */
}

@media screen and (max-width: 1600px) {
  .footer_li {
    margin-bottom: 12px;
  }
}

@media screen and (max-width: 1200px) {
  .footer_main_div {
    width: 100%;
    padding: 0 50px;
  }

  .footer_top_container {
    padding: 47px 0 60px 0;
    flex-direction: row;
    justify-content: space-between;
  }

  .footer_social_div {
    margin-top: 20px;
  }

  .footer_social_div > p {
    font-size: 18px;
  }

  .footer_social_icons {
    gap: 12px;
  }

  .footer_logo_div {
    width: 200px;
  }

  .footer_right_container {
    align-items: flex-start;
    flex-direction: row;
    justify-content: space-between;
    gap: 30px;
  }

  .footer_right_sub_container {
    flex-direction: row;
    gap: 30px;
  }

  .footer_card > p {
    color: #fff;
    font-family: Thicker;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-transform: uppercase;
  }

  .footer_card > ul {
    margin-top: 29px;
  }

  .footer_li {
    list-style: none;
    color: #fff;
    font-family: mediumThicker;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    cursor: pointer;
    margin-bottom: 8px;
    padding: 0;
  }

  .footer_bottom_container {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 50px 48px 50px;
  }

  .footer_bottom_copyright_div > p {
    color: #fff;
    font-family: lightThicker;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 40px;
  }

  .footer_bottom_privacy_policy_div {
    display: flex;
    flex-direction: row;
    gap: 48px;
  }

  .footer_bottom_privacy_policy_div > p {
    color: #fff;
    font-family: lightThicker;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 40px; /* 285.714% */
  }
}

@media screen and (max-width: 1024px) {
  .footer_main_div {
    width: 100%;
    padding: 0 40px;
  }

  .footer_top_container {
    padding: 47px 0 10px 0;
    flex-direction: row;
    justify-content: space-between;
  }

  .footer_social_div {
    margin-top: 20px;
  }

  .footer_social_div > p {
    font-size: 18px;
  }

  .footer_social_icons {
    gap: 12px;
  }

  .footer_logo_div {
    width: 180px;
  }

  .footer_right_container {
    align-items: flex-start;
    flex-direction: row;
    justify-content: space-between;
    gap: 50px;
  }

  .footer_right_sub_container {
    flex-direction: column;
    gap: 30px;
  }

  .footer_card {
    margin-bottom: 20px;
  }

  .footer_card > p {
    color: #fff;
    font-family: Thicker;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-transform: uppercase;
  }

  .footer_card > ul {
    margin-top: 22px;
  }

  .footer_li {
    list-style: none;
    color: #fff;
    font-family: mediumThicker;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    cursor: pointer;
    margin-bottom: 8px;
    padding: 0;
  }

  .footer_bottom_container {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 40px 30px 40px;
  }

  .footer_bottom_copyright_div > p {
    color: #fff;
    font-family: lightThicker;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 40px;
  }

  .footer_bottom_privacy_policy_div {
    display: flex;
    flex-direction: row;
    gap: 40px;
  }

  .footer_bottom_privacy_policy_div > p {
    color: #fff;
    font-family: lightThicker;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 40px; /* 285.714% */
  }
}

@media screen and (max-width: 800px) {
  .footer_main_div {
    width: 100%;
    padding: 0 30px;
  }

  .footer_top_container {
    padding: 47px 0 10px 0;
    flex-direction: row;
    justify-content: space-between;
  }

  .footer_social_div {
    margin-top: 20px;
  }

  .footer_social_div > p {
    font-size: 18px;
  }

  .footer_social_icons {
    gap: 12px;
  }

  .footer_right_container {
    align-items: flex-start;
    flex-direction: row;
    justify-content: space-between;
    gap: 30px;
  }

  .footer_right_sub_container {
    flex-direction: column;
    gap: 30px;
  }

  .footer_card {
    margin-bottom: 20px;
  }

  .footer_card > p {
    color: #fff;
    font-family: Thicker;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-transform: uppercase;
  }

  .footer_card > ul {
    margin-top: 22px;
  }

  .footer_li {
    list-style: none;
    color: #fff;
    font-family: mediumThicker;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    cursor: pointer;
    margin-bottom: 8px;
    padding: 0;
  }

  .footer_bottom_container {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 30px 30px 30px;
  }

  .footer_bottom_copyright_div > p {
    color: #fff;
    font-family: lightThicker;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 40px;
  }

  .footer_bottom_privacy_policy_div {
    display: flex;
    flex-direction: row;
    gap: 40px;
  }

  .footer_bottom_privacy_policy_div > p {
    color: #fff;
    font-family: lightThicker;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 40px; /* 285.714% */
  }
}

@media screen and (max-width: 700px) {
  .footer_main_div {
    width: 100%;
    padding: 0 30px;
  }

  .footer_top_container {
    padding: 47px 0 10px 0;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .footer_social_div {
    margin: 20px 0 30px 0;
  }

  .footer_social_div > p {
    font-size: 18px;
  }

  .footer_social_icons {
    gap: 12px;
  }

  .footer_right_container {
    align-items: flex-start;
    flex-direction: row;
    justify-content: space-between;
    gap: 70px;
  }

  .footer_right_sub_container {
    flex-direction: column;
    gap: 30px;
  }

  .footer_card {
    margin-bottom: 20px;
  }

  .footer_card > p {
    font-size: 16px;
  }

  .footer_card > ul {
    margin-top: 22px;
  }

  .footer_li {
    font-size: 16px;
    margin-bottom: 8px;
    padding: 0;
  }

  .footer_bottom_container {
    justify-content: space-between;
    padding: 14px 30px 30px 30px;
  }

  .footer_bottom_copyright_div > p {
    font-size: 14px;
    line-height: 20px;
  }

  .footer_bottom_privacy_policy_div {
    flex-direction: row;
    gap: 30px;
  }

  .footer_bottom_privacy_policy_div > p {
    font-size: 14px;
    line-height: 20px; /* 285.714% */
  }
}

@media screen and (max-width: 600px) {
  .footer_main_div {
    width: 100%;
    padding: 0 20px;
  }

  .footer_top_container {
    padding: 30px 0 10px 0;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .footer_social_div {
    margin: 20px 0 40px 0;
  }

  .footer_social_div > p {
    font-size: 18px;
  }

  .footer_social_icons {
    gap: 15px;
  }

  .footer_logo_div {
    width: 140px;
    height: 36px;
  }

  .footer_right_container {
    align-items: flex-start;
    flex-direction: row;
    justify-content: space-between;
    gap: 40px;
  }

  .footer_right_sub_container {
    flex-direction: column;
    gap: 10px;
  }

  .footer_card {
    margin-bottom: 20px;
  }

  .footer_card > p {
    font-size: 18px;
  }

  .footer_card > ul {
    margin-top: 12px;
  }

  .footer_li {
    font-size: 16px;
    margin-bottom: 4px;
    padding: 0;
  }

  .footer_bottom_container {
    justify-content: space-between;
    padding: 20px 20px 20px 20px;
  }

  .footer_bottom_copyright_div > p {
    font-size: 12px;
    line-height: 16px;
  }

  .footer_bottom_privacy_policy_div {
    flex-direction: row;
    gap: 16px;
  }

  .footer_bottom_privacy_policy_div > p {
    font-size: 12px;
    line-height: 16px; /* 285.714% */
  }
}

@media screen and (max-width: 450px) {
  .footer_main_div {
    width: 100%;
    padding: 10px 16px 0 16px;
  }

  .footer_top_container {
    padding: 15px 0 10px 0;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .footer_social_div {
    margin: 20px 0 30px 0;
  }

  .footer_social_div > p {
    font-size: 16px;
    margin-bottom: -5px;
  }

  .footer_social_icons {
    gap: 15px;
  }

  .footer_right_container {
    align-items: flex-start;
    flex-direction: row;
    justify-content: space-between;
    gap: 30px;
  }

  .footer_right_sub_container {
    flex-direction: column;
    gap: 10px;
  }

  .footer_card {
    margin-bottom: 16px;
  }

  .footer_card > p {
    font-size: 16px;
  }

  .footer_card > ul {
    margin-top: 12px;
  }

  .footer_li {
    font-size: 14px;
    margin-bottom: 8px;
    padding: 0;
  }

  .footer_bottom_container {
    justify-content: center;
    flex-direction: column-reverse;
    padding: 20px 16px 20px 16px;
  }

  .footer_bottom_copyright_div > p {
    font-size: 12px;
    line-height: 16px;
    margin-top: -10px;
  }

  .footer_bottom_privacy_policy_div {
    flex-direction: row;
    gap: 16px;
  }

  .footer_bottom_privacy_policy_div > p {
    font-size: 12px;
    line-height: 12px; /* 285.714% */
  }
}

@media screen and (max-width: 360px) {
  .footer_main_div {
    width: 100%;
  }

  .footer_top_container {
    padding: 15px 0 10px 0;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .footer_social_div {
    margin: 20px 0 30px 0;
  }

  .footer_social_div > p {
    font-size: 16px;
  }

  .footer_social_icons {
    gap: 15px;
  }

  .footer_right_container {
    align-items: flex-start;
    flex-direction: row;
    justify-content: space-between;
    gap: 16px;
  }

  .footer_right_sub_container {
    flex-direction: column;
    gap: 10px;
  }

  .footer_card {
    margin-bottom: 16px;
  }

  .footer_card > p {
    font-size: 16px;
  }

  .footer_card > ul {
    margin-top: 12px;
  }

  .footer_li {
    font-size: 14px;
    margin-bottom: 8px;
    padding: 0;
  }

  .footer_bottom_container {
    justify-content: center;
    flex-direction: column-reverse;
    padding: 20px 16px 20px 16px;
  }

  .footer_bottom_copyright_div > p {
    font-size: 12px;
    line-height: 16px;
    /* margin-top: 10px; */
  }

  .footer_bottom_privacy_policy_div {
    flex-direction: row;
    gap: 16px;
  }

  .footer_bottom_privacy_policy_div > p {
    font-size: 12px;
    line-height: 16px; /* 285.714% */
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/footer/footer.css"],"names":[],"mappings":";AACA;EACE,yBAAyB;EACzB,4CAAmD;AACrD;;AAEA;EACE,0BAA0B;EAC1B,4CAAmD;AACrD;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;;AAE3B;;;AAGA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,UAAU;EAKV,8BAA8B;AAChC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,8CAA8C;EAC9C,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc,CAAC;;AAEjB;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,4BAA4B;EAC9B;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,aAAa;EAClC;AACF;;AAEA;EACE;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,4BAA4B;EAC9B;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,aAAa;EAClC;AACF;;AAEA;EACE;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,4BAA4B;EAC9B;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,aAAa;EAClC;AACF;;AAEA;EACE;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;EACzB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,8BAA8B;IAC9B,4BAA4B;EAC9B;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,iBAAiB,EAAE,aAAa;EAClC;AACF;;AAEA;EACE;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;EACzB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,8BAA8B;IAC9B,4BAA4B;EAC9B;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,iBAAiB,EAAE,aAAa;EAClC;AACF;;AAEA;EACE;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;EACzB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,uBAAuB;IACvB,8BAA8B;IAC9B,4BAA4B;EAC9B;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,iBAAiB,EAAE,aAAa;EAClC;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;EACzB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,uBAAuB;IACvB,8BAA8B;IAC9B,4BAA4B;EAC9B;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,iBAAiB,EAAE,aAAa;EAClC;AACF","sourcesContent":["\n@font-face {\n  font-family: lightThicker;\n  src: url(../../../assets/fonts/Thicker-Regular.otf);\n}\n\n@font-face {\n  font-family: mediumThicker;\n  src: url(../../../assets/fonts/Thicker-Regular.otf);\n}\n\n.footer_wrapper {\n  width: 100%;\n  background: #262626;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.footer_main_div {\n  width:100%;\n  padding: 0 6vw;\n}\n\n.footer_top_container {\n  padding: 47px 0 60px 0;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.footer_social_div {\n  margin-top: 20px;\n}\n\n.footer_social_div > p {\n  font-family: mediumThicker;\n  color: #fff;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n}\n\n.footer_social_icons {\n  display: flex;\n  gap: 12px;\n  cursor: pointer;\n  margin-top: 10px;\n}\n\n.footer_logo_div {\n  width: 230px;\n}\n\n.footer_right_container {\n  display: flex;\n  align-items: flex-start;\n  flex-direction: row;\n  justify-content: space-between;\n  gap: 66px;\n}\n\n.footer_right_sub_container {\n  display: flex;\n  flex-direction: row;\n  gap: 66px;\n}\n\n.footer_card > p {\n  color: #fff;\n  font-family: Thicker;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  text-transform: uppercase;\n\n}\n\n\n.footer_card > ul {\n  margin-top: 29px;\n  padding: 0px;\n}\n.comingSoon{\n  font-size: 12px;\n  color: crimson;\n}\n.footer_li {\n  list-style: none;\n  color: #fff;\n  font-family: mediumThicker;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  cursor: pointer;\n  margin-bottom: 18px;\n  padding: 0;\n  -webkit-transition: color 0.1s;\n  -moz-transition:    color 0.1s;\n  -ms-transition:     color 0.1s;\n  -o-transition:      color 0.1s;\n  transition:         color 0.1s;\n}\n.footer_li:hover {\n  color: rgb(198, 196, 196);\n}\n.footer_bottom_container_wrapper {\n  width: 100%;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  background: #262626;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.footer_bottom_container {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 6vw;}\n\n.footer_bottom_copyright_div > p {\n  color: #fff;\n  font-family: lightThicker;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 40px;\n}\n\n.footer_bottom_privacy_policy_div {\n  display: flex;\n  flex-direction: row;\n  gap: 48px;\n}\n\n.footer_bottom_privacy_policy_div > p {\n  color: #fff;\n  font-family: lightThicker;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 40px; /* 285.714% */\n}\n\n@media screen and (max-width: 1600px) {\n  .footer_li {\n    margin-bottom: 12px;\n  }\n}\n\n@media screen and (max-width: 1200px) {\n  .footer_main_div {\n    width: 100%;\n    padding: 0 50px;\n  }\n\n  .footer_top_container {\n    padding: 47px 0 60px 0;\n    flex-direction: row;\n    justify-content: space-between;\n  }\n\n  .footer_social_div {\n    margin-top: 20px;\n  }\n\n  .footer_social_div > p {\n    font-size: 18px;\n  }\n\n  .footer_social_icons {\n    gap: 12px;\n  }\n\n  .footer_logo_div {\n    width: 200px;\n  }\n\n  .footer_right_container {\n    align-items: flex-start;\n    flex-direction: row;\n    justify-content: space-between;\n    gap: 30px;\n  }\n\n  .footer_right_sub_container {\n    flex-direction: row;\n    gap: 30px;\n  }\n\n  .footer_card > p {\n    color: #fff;\n    font-family: Thicker;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    text-transform: uppercase;\n  }\n\n  .footer_card > ul {\n    margin-top: 29px;\n  }\n\n  .footer_li {\n    list-style: none;\n    color: #fff;\n    font-family: mediumThicker;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    cursor: pointer;\n    margin-bottom: 8px;\n    padding: 0;\n  }\n\n  .footer_bottom_container {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 14px 50px 48px 50px;\n  }\n\n  .footer_bottom_copyright_div > p {\n    color: #fff;\n    font-family: lightThicker;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 40px;\n  }\n\n  .footer_bottom_privacy_policy_div {\n    display: flex;\n    flex-direction: row;\n    gap: 48px;\n  }\n\n  .footer_bottom_privacy_policy_div > p {\n    color: #fff;\n    font-family: lightThicker;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 40px; /* 285.714% */\n  }\n}\n\n@media screen and (max-width: 1024px) {\n  .footer_main_div {\n    width: 100%;\n    padding: 0 40px;\n  }\n\n  .footer_top_container {\n    padding: 47px 0 10px 0;\n    flex-direction: row;\n    justify-content: space-between;\n  }\n\n  .footer_social_div {\n    margin-top: 20px;\n  }\n\n  .footer_social_div > p {\n    font-size: 18px;\n  }\n\n  .footer_social_icons {\n    gap: 12px;\n  }\n\n  .footer_logo_div {\n    width: 180px;\n  }\n\n  .footer_right_container {\n    align-items: flex-start;\n    flex-direction: row;\n    justify-content: space-between;\n    gap: 50px;\n  }\n\n  .footer_right_sub_container {\n    flex-direction: column;\n    gap: 30px;\n  }\n\n  .footer_card {\n    margin-bottom: 20px;\n  }\n\n  .footer_card > p {\n    color: #fff;\n    font-family: Thicker;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    text-transform: uppercase;\n  }\n\n  .footer_card > ul {\n    margin-top: 22px;\n  }\n\n  .footer_li {\n    list-style: none;\n    color: #fff;\n    font-family: mediumThicker;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    cursor: pointer;\n    margin-bottom: 8px;\n    padding: 0;\n  }\n\n  .footer_bottom_container {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 14px 40px 30px 40px;\n  }\n\n  .footer_bottom_copyright_div > p {\n    color: #fff;\n    font-family: lightThicker;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 40px;\n  }\n\n  .footer_bottom_privacy_policy_div {\n    display: flex;\n    flex-direction: row;\n    gap: 40px;\n  }\n\n  .footer_bottom_privacy_policy_div > p {\n    color: #fff;\n    font-family: lightThicker;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 40px; /* 285.714% */\n  }\n}\n\n@media screen and (max-width: 800px) {\n  .footer_main_div {\n    width: 100%;\n    padding: 0 30px;\n  }\n\n  .footer_top_container {\n    padding: 47px 0 10px 0;\n    flex-direction: row;\n    justify-content: space-between;\n  }\n\n  .footer_social_div {\n    margin-top: 20px;\n  }\n\n  .footer_social_div > p {\n    font-size: 18px;\n  }\n\n  .footer_social_icons {\n    gap: 12px;\n  }\n\n  .footer_right_container {\n    align-items: flex-start;\n    flex-direction: row;\n    justify-content: space-between;\n    gap: 30px;\n  }\n\n  .footer_right_sub_container {\n    flex-direction: column;\n    gap: 30px;\n  }\n\n  .footer_card {\n    margin-bottom: 20px;\n  }\n\n  .footer_card > p {\n    color: #fff;\n    font-family: Thicker;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    text-transform: uppercase;\n  }\n\n  .footer_card > ul {\n    margin-top: 22px;\n  }\n\n  .footer_li {\n    list-style: none;\n    color: #fff;\n    font-family: mediumThicker;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    cursor: pointer;\n    margin-bottom: 8px;\n    padding: 0;\n  }\n\n  .footer_bottom_container {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 14px 30px 30px 30px;\n  }\n\n  .footer_bottom_copyright_div > p {\n    color: #fff;\n    font-family: lightThicker;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 40px;\n  }\n\n  .footer_bottom_privacy_policy_div {\n    display: flex;\n    flex-direction: row;\n    gap: 40px;\n  }\n\n  .footer_bottom_privacy_policy_div > p {\n    color: #fff;\n    font-family: lightThicker;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 40px; /* 285.714% */\n  }\n}\n\n@media screen and (max-width: 700px) {\n  .footer_main_div {\n    width: 100%;\n    padding: 0 30px;\n  }\n\n  .footer_top_container {\n    padding: 47px 0 10px 0;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n  }\n\n  .footer_social_div {\n    margin: 20px 0 30px 0;\n  }\n\n  .footer_social_div > p {\n    font-size: 18px;\n  }\n\n  .footer_social_icons {\n    gap: 12px;\n  }\n\n  .footer_right_container {\n    align-items: flex-start;\n    flex-direction: row;\n    justify-content: space-between;\n    gap: 70px;\n  }\n\n  .footer_right_sub_container {\n    flex-direction: column;\n    gap: 30px;\n  }\n\n  .footer_card {\n    margin-bottom: 20px;\n  }\n\n  .footer_card > p {\n    font-size: 16px;\n  }\n\n  .footer_card > ul {\n    margin-top: 22px;\n  }\n\n  .footer_li {\n    font-size: 16px;\n    margin-bottom: 8px;\n    padding: 0;\n  }\n\n  .footer_bottom_container {\n    justify-content: space-between;\n    padding: 14px 30px 30px 30px;\n  }\n\n  .footer_bottom_copyright_div > p {\n    font-size: 14px;\n    line-height: 20px;\n  }\n\n  .footer_bottom_privacy_policy_div {\n    flex-direction: row;\n    gap: 30px;\n  }\n\n  .footer_bottom_privacy_policy_div > p {\n    font-size: 14px;\n    line-height: 20px; /* 285.714% */\n  }\n}\n\n@media screen and (max-width: 600px) {\n  .footer_main_div {\n    width: 100%;\n    padding: 0 20px;\n  }\n\n  .footer_top_container {\n    padding: 30px 0 10px 0;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n  }\n\n  .footer_social_div {\n    margin: 20px 0 40px 0;\n  }\n\n  .footer_social_div > p {\n    font-size: 18px;\n  }\n\n  .footer_social_icons {\n    gap: 15px;\n  }\n\n  .footer_logo_div {\n    width: 140px;\n    height: 36px;\n  }\n\n  .footer_right_container {\n    align-items: flex-start;\n    flex-direction: row;\n    justify-content: space-between;\n    gap: 40px;\n  }\n\n  .footer_right_sub_container {\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .footer_card {\n    margin-bottom: 20px;\n  }\n\n  .footer_card > p {\n    font-size: 18px;\n  }\n\n  .footer_card > ul {\n    margin-top: 12px;\n  }\n\n  .footer_li {\n    font-size: 16px;\n    margin-bottom: 4px;\n    padding: 0;\n  }\n\n  .footer_bottom_container {\n    justify-content: space-between;\n    padding: 20px 20px 20px 20px;\n  }\n\n  .footer_bottom_copyright_div > p {\n    font-size: 12px;\n    line-height: 16px;\n  }\n\n  .footer_bottom_privacy_policy_div {\n    flex-direction: row;\n    gap: 16px;\n  }\n\n  .footer_bottom_privacy_policy_div > p {\n    font-size: 12px;\n    line-height: 16px; /* 285.714% */\n  }\n}\n\n@media screen and (max-width: 450px) {\n  .footer_main_div {\n    width: 100%;\n    padding: 10px 16px 0 16px;\n  }\n\n  .footer_top_container {\n    padding: 15px 0 10px 0;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n  }\n\n  .footer_social_div {\n    margin: 20px 0 30px 0;\n  }\n\n  .footer_social_div > p {\n    font-size: 16px;\n    margin-bottom: -5px;\n  }\n\n  .footer_social_icons {\n    gap: 15px;\n  }\n\n  .footer_right_container {\n    align-items: flex-start;\n    flex-direction: row;\n    justify-content: space-between;\n    gap: 30px;\n  }\n\n  .footer_right_sub_container {\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .footer_card {\n    margin-bottom: 16px;\n  }\n\n  .footer_card > p {\n    font-size: 16px;\n  }\n\n  .footer_card > ul {\n    margin-top: 12px;\n  }\n\n  .footer_li {\n    font-size: 14px;\n    margin-bottom: 8px;\n    padding: 0;\n  }\n\n  .footer_bottom_container {\n    justify-content: center;\n    flex-direction: column-reverse;\n    padding: 20px 16px 20px 16px;\n  }\n\n  .footer_bottom_copyright_div > p {\n    font-size: 12px;\n    line-height: 16px;\n    margin-top: -10px;\n  }\n\n  .footer_bottom_privacy_policy_div {\n    flex-direction: row;\n    gap: 16px;\n  }\n\n  .footer_bottom_privacy_policy_div > p {\n    font-size: 12px;\n    line-height: 12px; /* 285.714% */\n  }\n}\n\n@media screen and (max-width: 360px) {\n  .footer_main_div {\n    width: 100%;\n  }\n\n  .footer_top_container {\n    padding: 15px 0 10px 0;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n  }\n\n  .footer_social_div {\n    margin: 20px 0 30px 0;\n  }\n\n  .footer_social_div > p {\n    font-size: 16px;\n  }\n\n  .footer_social_icons {\n    gap: 15px;\n  }\n\n  .footer_right_container {\n    align-items: flex-start;\n    flex-direction: row;\n    justify-content: space-between;\n    gap: 16px;\n  }\n\n  .footer_right_sub_container {\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .footer_card {\n    margin-bottom: 16px;\n  }\n\n  .footer_card > p {\n    font-size: 16px;\n  }\n\n  .footer_card > ul {\n    margin-top: 12px;\n  }\n\n  .footer_li {\n    font-size: 14px;\n    margin-bottom: 8px;\n    padding: 0;\n  }\n\n  .footer_bottom_container {\n    justify-content: center;\n    flex-direction: column-reverse;\n    padding: 20px 16px 20px 16px;\n  }\n\n  .footer_bottom_copyright_div > p {\n    font-size: 12px;\n    line-height: 16px;\n    /* margin-top: 10px; */\n  }\n\n  .footer_bottom_privacy_policy_div {\n    flex-direction: row;\n    gap: 16px;\n  }\n\n  .footer_bottom_privacy_policy_div > p {\n    font-size: 12px;\n    line-height: 16px; /* 285.714% */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
